import * as React from "react";
const SvgSwitchVertical = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <g clipPath="url(#switch-vertical_svg__a)">
      <path
        stroke="#505050"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M12.889 2.778v12.444m0 0-3.111-3.11m3.11 3.11L16 12.112m-10.889 3.11V2.778m0 0L2 5.888m3.111-3.11 3.111 3.11"
      />
    </g>
    <defs>
      <clipPath id="switch-vertical_svg__a">
        <path fill="#fff" d="M0 18V0h18v18z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwitchVertical;
